export default __webpack_public_path__ + "static/media/facebook.9421c7a5.png";